/**
 * Catálogo ERP do zero.
 * Cada item = um papel/função necessário no ERP (todos podem coexistir).
 * Cada papel tem 3 variações VISUAIS — o time escolhe 1 estilo por papel.
 */

const CATALOG = [
  {
    grupo: 'Ícones',
    items: [
      {
        id: 'icons',
        nome: 'Catálogo de ícones',
        paraQue: 'Só a coleção UI Oval da MIV. Os principais recebem a função a partir do uso atual das telas do Oikos. O restante da coleção abre como opção.',
        variantes: [{ id: 'A', nome: 'Grade por categoria', mock: 'iconCatalog' }],
      },
    ],
  },
  {
    grupo: 'Botões',
    items: [
      {
        id: 'btn-confirm',
        nome: 'Botão confirmar / salvar',
        paraQue: 'Ação principal afirmativa (salvar, confirmar, enviar).',
        variantes: [
          { id: 'A', nome: 'Preenchido (accent)', mock: 'btnConfirmA' },
          { id: 'B', nome: 'Preenchido escuro', mock: 'btnConfirmB' },
          { id: 'C', nome: 'Com ícone à esquerda', mock: 'btnConfirmC' },
        ],
      },
      {
        id: 'btn-cancel',
        nome: 'Botão cancelar / voltar',
        paraQue: 'Descartar ou sair sem gravar.',
        variantes: [
          { id: 'A', nome: 'Outline', mock: 'btnCancelA' },
          { id: 'B', nome: 'Só texto (ghost)', mock: 'btnCancelB' },
          { id: 'C', nome: 'Fundo cinza suave', mock: 'btnCancelC' },
        ],
      },
      {
        id: 'btn-delete',
        nome: 'Botão excluir / destrutivo',
        paraQue: 'Ação irreversível ou perigosa.',
        variantes: [
          { id: 'A', nome: 'Preenchido vermelho', mock: 'btnDeleteA' },
          { id: 'B', nome: 'Outline vermelho', mock: 'btnDeleteB' },
          { id: 'C', nome: 'Só ícone + rótulo', mock: 'btnDeleteC' },
        ],
      },
    ],
  },
  {
    grupo: 'Campos',
    items: [
      {
        id: 'input-line',
        nome: 'Campo de texto (linha)',
        paraQue: 'Nome, e-mail, códigos curtos.',
        variantes: [
          { id: 'A', nome: 'Borda completa', mock: 'inputLineA' },
          { id: 'B', nome: 'Só underline', mock: 'inputLineB' },
          { id: 'C', nome: 'Fundo preenchido', mock: 'inputLineC' },
        ],
      },
      {
        id: 'input-area',
        nome: 'Área de texto',
        paraQue: 'Observações, descrições longas.',
        variantes: [
          { id: 'A', nome: 'Borda simples', mock: 'inputAreaA' },
          { id: 'B', nome: 'Com contador', mock: 'inputAreaB' },
          { id: 'C', nome: 'Redimensionável marcada', mock: 'inputAreaC' },
        ],
      },
      {
        id: 'input-mask',
        nome: 'Campo com máscara',
        paraQue: 'CPF, CNPJ, telefone, moeda. Usa o MaskedInput do Oikos (react-imask).',
        variantes: [
          { id: 'A', nome: 'Máscara visível no placeholder', mock: 'inputMaskA' },
          { id: 'B', nome: 'Prefixo fixo (R$ / +55)', mock: 'inputMaskB' },
          { id: 'C', nome: 'Validação inline (ok/erro)', mock: 'inputMaskC' },
        ],
      },
      {
        id: 'select',
        nome: 'Select (lista fechada)',
        paraQue:
          'Status, tipo, enums. O padrão do Oikos é o Select novo: react-select em components/Template/Input/Select.js. O <select> nativo não é o das telas.',
        variantes: [
          { id: 'A', nome: 'Select do Oikos (react-select)', mock: 'selectA' },
          { id: 'B', nome: 'Dropdown custom', mock: 'selectB' },
          { id: 'C', nome: 'Com busca no dropdown', mock: 'selectC' },
        ],
      },
      {
        id: 'select-async',
        nome: 'Select com busca (typeahead)',
        paraQue: 'Fornecedor, projeto, PF/PJ em listas grandes. Mesmo Select novo (react-select), com busca.',
        variantes: [
          { id: 'A', nome: 'Lista abaixo do campo', mock: 'selectAsyncA' },
          { id: 'B', nome: 'Com avatar/meta', mock: 'selectAsyncB' },
          { id: 'C', nome: 'Com “criar novo” no rodapé', mock: 'selectAsyncC' },
        ],
      },
      {
        id: 'select-multi',
        nome: 'Multi-select',
        paraQue:
          'Vários valores. É o mesmo Select novo do Oikos, com isMulti. Não há um multi-select antigo em paralelo.',
        variantes: [
          { id: 'A', nome: 'isMulti no Select do Oikos', mock: 'selectMultiA' },
          { id: 'B', nome: 'Checklist no dropdown', mock: 'selectMultiB' },
          { id: 'C', nome: 'Chips + contador “+N”', mock: 'selectMultiC' },
        ],
      },
      {
        id: 'date',
        nome: 'Seletor de data',
        paraQue: 'Prazo, vigência, competência.',
        variantes: [
          { id: 'A', nome: 'Input + ícone calendário', mock: 'dateA' },
          { id: 'B', nome: 'Popovers lado a lado (de–até)', mock: 'dateB' },
          { id: 'C', nome: 'Data e hora no mesmo bloco', mock: 'dateC' },
        ],
      },
      {
        id: 'toggle',
        nome: 'Switch / toggle',
        paraQue: 'Ativo/inativo, flags booleanas.',
        variantes: [
          { id: 'A', nome: 'Switch clássico', mock: 'toggleA' },
          { id: 'B', nome: 'Switch com Sim/Não', mock: 'toggleB' },
          { id: 'C', nome: 'Checkbox grande estilizado', mock: 'toggleC' },
        ],
      },
    ],
  },
  {
    grupo: 'Listagem e dados',
    items: [
      {
        id: 'kanban',
        nome: 'Kanban',
        paraQue:
          'Modelo genérico do quadro de Gestão de atividades. Três colunas de status, contagem, incluir na primeira, cartão com alça, título e uma linha secundária. Arrastar muda a coluna ou a ordem, com marca antes/depois. Coluna sem cartão mostra o vazio. Projeto, tarefa e natureza dessa tela não entram no modelo.',
        fullWidth: true,
        variantes: [{ id: 'A', nome: 'Quadro', mock: 'kanbanA' }],
      },
      {
        id: 'table',
        nome: 'Tabela de dados',
        paraQue: 'A listagem do Oikos: MaterialReactTable com densidade compacta, busca, filtro de coluna e paginação embaixo, como em Produtos e Contratos.',
        variantes: [
          { id: 'A', nome: 'Listagem MRT', mock: 'tableA' },
          { id: 'B', nome: 'Mesma listagem, filtro na coluna', mock: 'tableB' },
          { id: 'C', nome: 'Mesma listagem, paginação', mock: 'tableC' },
        ],
      },
      {
        id: 'kpi',
        nome: 'Card KPI',
        paraQue: 'Indicadores no dashboard.',
        variantes: [
          { id: 'A', nome: 'Número + rótulo', mock: 'kpiA' },
          { id: 'B', nome: 'Com variação %', mock: 'kpiB' },
          { id: 'C', nome: 'Com barra de meta', mock: 'kpiC' },
        ],
      },
      {
        id: 'card-panel',
        nome: 'Card / painel genérico',
        paraQue: 'Container de conteúdo (não só KPI): título, corpo e ações.',
        variantes: [
          { id: 'A', nome: 'Título + corpo', mock: 'cardPanelA' },
          { id: 'B', nome: 'Com ações no rodapé', mock: 'cardPanelB' },
          { id: 'C', nome: 'Com meta / tag', mock: 'cardPanelC' },
        ],
      },
      {
        id: 'filter',
        nome: 'Filtros de listagem',
        paraQue: 'O filtro da listagem é o filtro de coluna dessa mesma tabela MRT.',
        variantes: [
          { id: 'A', nome: 'Filtro de coluna do MRT', mock: 'filterA' },
          { id: 'B', nome: 'Chips de filtros ativos', mock: 'filterB' },
          { id: 'C', nome: 'Drawer de filtros', mock: 'filterC' },
        ],
      },
    ],
  },
  {
    grupo: 'Formulário e página',
    items: [
      {
        id: 'form-layout',
        nome: 'Layout de formulário',
        paraQue: 'Organizar campos de cadastro/edição.',
        variantes: [
          { id: 'A', nome: 'Uma coluna', mock: 'formA' },
          { id: 'B', nome: 'Duas colunas', mock: 'formB' },
          { id: 'C', nome: 'Seções recolhíveis', mock: 'formC' },
        ],
      },
      {
        id: 'tabs',
        nome: 'Abas (tabs)',
        paraQue: 'As abas do Oikos são o Nav tabs do Reactstrap, com a classe nav-tabs-custom.',
        variantes: [
          { id: 'A', nome: 'Abas horizontais', mock: 'tabsA' },
          { id: 'B', nome: 'Abas com contagem', mock: 'tabsB' },
          { id: 'C', nome: 'Abas compactas', mock: 'tabsC' },
        ],
      },
      {
        id: 'accordion',
        nome: 'Accordion',
        paraQue: 'Seções recolhíveis independentes (átomo L1; também em L2/L3).',
        variantes: [
          { id: 'A', nome: 'Uma aberta por vez', mock: 'accordionA' },
          { id: 'B', nome: 'Várias abertas', mock: 'accordionB' },
          { id: 'C', nome: 'Só títulos densos', mock: 'accordionC' },
        ],
      },
      {
        id: 'page-header',
        nome: 'Cabeçalho de página',
        paraQue: 'Título, contexto e ações da tela.',
        variantes: [
          { id: 'A', nome: 'Só título', mock: 'pageA' },
          { id: 'B', nome: 'Título + breadcrumb', mock: 'pageB' },
          { id: 'C', nome: 'Título + ações à direita', mock: 'pageC' },
        ],
      },
      {
        id: 'nav',
        nome: 'Navegação principal',
        paraQue: 'Módulos do ERP.',
        variantes: [
          { id: 'A', nome: 'Topbar com menus', mock: 'navA' },
          { id: 'B', nome: 'Sidebar', mock: 'navB' },
          { id: 'C', nome: 'Topbar + tabs de seção', mock: 'navC' },
        ],
      },
    ],
  },
  {
    grupo: 'Sobreposição',
    items: [
      {
        id: 'modal-confirm',
        nome: 'Modal de confirmação',
        paraQue: 'Perguntar antes de ação sensível. O Oikos já usa o Modal do Reactstrap em components/Modals — manter esse.',
        variantes: [
          { id: 'A', nome: 'Centrado, 2 botões', mock: 'modalConfirmA' },
          { id: 'B', nome: 'Com ícone de alerta', mock: 'modalConfirmB' },
          { id: 'C', nome: 'Destrutivo destacado', mock: 'modalConfirmC' },
        ],
      },
      {
        id: 'modal-form',
        nome: 'Modal de formulário',
        paraQue: 'Criar/editar sem sair da lista.',
        variantes: [
          { id: 'A', nome: 'Compacto (sm)', mock: 'modalFormA' },
          { id: 'B', nome: 'Médio com 2 campos+', mock: 'modalFormB' },
          { id: 'C', nome: 'Largo com abas', mock: 'modalFormC' },
        ],
      },
      {
        id: 'drawer',
        nome: 'Painel lateral (drawer)',
        paraQue: 'Detalhe ou edição mantendo a lista visível.',
        variantes: [
          { id: 'A', nome: 'Só leitura', mock: 'drawerA' },
          { id: 'B', nome: 'Edição', mock: 'drawerB' },
          { id: 'C', nome: 'Filtros', mock: 'drawerC' },
        ],
      },
    ],
  },
  {
    grupo: 'Feedback e status',
    items: [
      {
        id: 'loading',
        nome: 'Estado de carregamento',
        paraQue: 'Indicar espera (spinner e/ou skeleton de tabela/form).',
        variantes: [
          { id: 'A', nome: 'Spinner centrado', mock: 'loadingA' },
          { id: 'B', nome: 'Skeleton de linhas', mock: 'loadingB' },
          { id: 'C', nome: 'Inline no botão/campo', mock: 'loadingC' },
        ],
      },
      {
        id: 'alert-banner',
        nome: 'Alerta / banner',
        paraQue: 'Aviso ou erro persistente na página/formulário (não some sozinho como toast).',
        variantes: [
          { id: 'A', nome: 'Erro', mock: 'alertBannerA' },
          { id: 'B', nome: 'Aviso', mock: 'alertBannerB' },
          { id: 'C', nome: 'Info + ação', mock: 'alertBannerC' },
        ],
      },
      {
        id: 'toast',
        nome: 'Toast / notificação',
        paraQue: 'Feedback rápido pós-ação.',
        variantes: [
          { id: 'A', nome: 'Canto superior', mock: 'toastA' },
          { id: 'B', nome: 'Barra inferior', mock: 'toastB' },
          { id: 'C', nome: 'Inline sob o formulário', mock: 'toastC' },
        ],
      },
      {
        id: 'empty',
        nome: 'Empty state',
        paraQue: 'Lista ou busca sem resultados.',
        variantes: [
          { id: 'A', nome: 'Texto + CTA', mock: 'emptyA' },
          { id: 'B', nome: 'Ilustração mínima + CTA', mock: 'emptyB' },
          { id: 'C', nome: 'Só mensagem discreta', mock: 'emptyC' },
        ],
      },
      {
        id: 'status-badge',
        nome: 'Badge de status',
        paraQue: 'Estado de um registro em lista/card.',
        variantes: [
          { id: 'A', nome: 'Pill colorida', mock: 'badgeA' },
          { id: 'B', nome: 'Dot + texto', mock: 'badgeB' },
          { id: 'C', nome: 'Outline colorido', mock: 'badgeC' },
        ],
      },
      {
        id: 'stepper',
        nome: 'Stepper / etapas',
        paraQue: 'Workflow (elaboração → aprovação → fim).',
        variantes: [
          { id: 'A', nome: 'Horizontal com linhas', mock: 'stepA' },
          { id: 'B', nome: 'Números em círculos', mock: 'stepB' },
          { id: 'C', nome: 'Timeline vertical', mock: 'stepC' },
        ],
      },
    ],
  },
  {
    grupo: 'Arquivos, gráficos, domínio',
    items: [
      {
        id: 'upload',
        nome: 'Upload / anexos',
        paraQue:
          'O Oikos já tem upload em components/Template/Files (AddFiles, CompactAddFiles). A variante A mostra o componente atual. Trocar por outro ainda não foi decidido.',
        variantes: [
          { id: 'A', nome: 'Botão + lista', mock: 'uploadA' },
          { id: 'B', nome: 'Zona drag-and-drop', mock: 'uploadB' },
          { id: 'C', nome: 'Grade de miniaturas', mock: 'uploadC' },
        ],
      },
      {
        id: 'chart',
        nome: 'Gráfico',
        paraQue:
          'A ferramenta do Gustavo continua em public/erp-design/gerador-de-graficos-ecossis.html. Desmontar esse arquivo para reutilizar o gráfico em outras telas fica para outra hora.',
        variantes: [
          { id: 'A', nome: 'Barras', mock: 'chartA' },
          { id: 'B', nome: 'Linha', mock: 'chartB' },
          { id: 'C', nome: 'Pizza / fatias', mock: 'chartC' },
        ],
      },
      {
        id: 'money',
        nome: 'Exibição de valor',
        paraQue: 'Moeda e breakdowns financeiros.',
        variantes: [
          { id: 'A', nome: 'Valor grande destacado', mock: 'moneyA' },
          { id: 'B', nome: 'Tabela breakdown', mock: 'moneyB' },
          { id: 'C', nome: 'Extrato (crédito/débito)', mock: 'moneyC' },
        ],
      },
    ],
  },
]

export function flattenCatalog() {
  const out = []
  CATALOG.forEach((g) => {
    g.items.forEach((item) => {
      out.push({ ...item, grupo: g.grupo })
    })
  })
  return out
}

export default CATALOG
